var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CreatePicklPopup", {
        attrs: {
          userId: _vm.userId,
          OnBoarded: _vm.onBoarded,
          LoadingBrand: _vm.LoadingBrand,
          brandId: _vm.brandId,
          popupId: "create-pickl-popup",
          surveyFeatureAvailable: _vm.surveyFeatureAvailable,
          lockPicklFeature: _vm.lockPicklFeature
        },
        on: { UpdatePicklList: _vm.picklCreated }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }